import { render, staticRenderFns } from "./SettingsPlane.vue?vue&type=template&id=a8c2e7ec&lang=pug&"
import script from "./SettingsPlane.vue?vue&type=script&lang=js&"
export * from "./SettingsPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports